import { connect } from 'react-redux';
import MaxwellIA from './MaxwellIA.jsx';
import { cargarSSOUrl } from '../actions/Actions.js';

const mapStateToProps = (state) => {
    const portico       = JSON.parse(localStorage.portico);
    const menuProductos = portico.menuProductos;

    return {
        ssoUrl:       state.maxwellIA.ssoUrl,
        error:        state.maxwellIA.error,
        mostrarModal: state.maxwellIA.mostrarModal,
        modalMensaje: state.maxwellIA.modalMensaje,
        email:  menuProductos.email    || "",
        nombre: menuProductos.userName || "",
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        cargarSSOUrl: (email, nombre) => {
            dispatch(cargarSSOUrl(email, nombre));
        },
        mostrarOcultarModal: (valor) => {
            dispatch({ type: 'MAXWELL_IA_MOSTRAR_MODAL', mostrarModal: valor });
        }
    };
};

const MaxwellIAContainer = connect(mapStateToProps, mapDispatchToProps)(MaxwellIA);

export default MaxwellIAContainer;
